import React, {useMemo, useState} from 'react';
import {Img} from "react-image";
import LoadingSpinner from "../../../components/LoadingSpinner";
import UserImageCircle from "../../../components/UserImageCircle";
import {Modal} from "antd";
import LoadingBanner from "../../../components/LoadingBanner";
import ErrorBanner from "../../../components/ErrorBanner";
import {useAPI} from "../../../config/API";
import User from "../../../models/User";
import Interview from "../../../models/Interview";
import {useAuth} from "../../../providers/AuthProvider";
import TalentCapabilityAssessmentModal, {CapabilityScoreSummary} from "./TalentCapabilityAssessmentModal";
import AvailabilityPanel from "../../talent-dashboard/components/AvailabilityPanel";
import {Link} from "react-router-dom";
import {useMutation, useQueryClient} from "@tanstack/react-query";

const AssessmentModal = (props) => {

    // let talent = props.talent;

    const {auth} = useAuth();
    const [isEditing, setIsEditing] = useState(false);
    const queryClient = useQueryClient()
    let {
        data: talent,
        isFetching: isLoading,
        error,
        refetch
    } = useAPI(['fetchForTalentAsManager', {talentId: props.talentId}], {})


    const updateTalentAssessmentMutation = useMutation(['updateTalentAssessment', props.talentId],
        async ({assessment}) => {
        let mappedAssessment = {};

        for (let [prop, value] of Object.entries(assessment)) {
            if (!TB.isDefined(value) || TB.isNaN(value)) {
                value = null;
            }
            TB.set(mappedAssessment, prop, value);
        }

        if (mappedAssessment.talent_disciplines?.length) {
            mappedAssessment.talent_disciplines = TB.map(mappedAssessment.talent_disciplines, (updatedDiscipline, i) => {

                let discipline = {...(talent.talent_disciplines[i] || {})};

                let approval_props = {
                    is_approved: null,
                    is_rejected: null,
                }
                if (updatedDiscipline.is_approved === true) {
                    approval_props.is_approved = true;
                } else if (updatedDiscipline.is_approved === false) {
                    approval_props.is_rejected = true;
                }
                return {
                    ...discipline,
                    ...updatedDiscipline,
                    is_approved: !!updatedDiscipline.is_approved
                }
            })
        }

        if (mappedAssessment.talent_service_groups?.length) {
            mappedAssessment.talent_service_groups = TB.map(mappedAssessment.talent_service_groups, (updatedService, i) => {

                let service = {...(talent.talent_service_groups[i] || {})};
                return {
                    ...service,
                    ...updatedService,
                    is_approved: !!updatedService.is_approved
                }
            })
        }

        let {
            talent_service_groups = [],
            talent_disciplines = [],
            skills,
            talent_skill_score,
            ...interview
        } = mappedAssessment;


        interview[`${type()}_interviewer_id`] = auth?.id

        let interviewUpdateParams = {
            interview
        }
        if (type() === 'capability') {
            interviewUpdateParams = {
                interview,
                talent_disciplines,
                talent_service_groups,
                talent_skill_score
            }
        }

        let updatedTalent = await User.submitInterview(props.talentId, interviewUpdateParams);

        if (!updatedTalent) {
            throw new Error('Something Went Wrong')
        }
        return updatedTalent
    }, {
        onSuccess: async (response) => {
            await setIsEditing(false)

            $('.ant-modal-wrap')?.animate({scrollTop: 0}, 1000);

            await TB.wait(1000)
            await queryClient.setQueriesData(['fetchForTalentAsManager', {talentId: props.talentId}], response);

            return TB.toast(`${TB.startCase(type())} Assessment Submitted`)
        },
        onError: e => {
            console.error("updateTalentAssessment", e);
            TB.showServerErrorToast();
        }
    })
    const profileScoring = () => {
        return [
            {
                label: 'Roles',
                propName: 'talent_disciplines',
                scorable: true
            },
            {
                label: 'Skills',
                propName: 'skills'
            },
            {
                label: 'Project Interests',
                propName: 'talent_service_groups',
                scorable: true
            },
            {
                label: 'Industry Experience',
                propName: 'industries_worked'
            }
        ]
    }


    const selfScore = (score) => {
        return laravel.talent_scoring_options[score]
    }

    const type = () => {
        return props.type
    }


    const approveAssessment = async (formModel) => {
        if (await checkAssessmentProgress()) {

            let interview = Interview.make({
                ...formModel,
                [`${type()}_approved_at`]: new Date(),
                [`${type()}_rejected_at`]: null
            });
            if (!interview.is_approved && interview.hrWasApproved() && interview.capabilityWasApproved()) {
                interview.is_approved = true;
            }

            return submitAssessment({...interview})
        }
    }

    const rejectAssessment = async (formModel) => {
        if (await checkAssessmentProgress()) {
            let interview = Interview.make({
                ...formModel,
                [`${type()}_rejected_at`]: new Date(),
                [`${type()}_approved_at`]: null
            });

            if (!interview.is_approved && interview.hrWasApproved() && interview.capabilityWasApproved()) {
                interview.is_approved = true;
            }

            return submitAssessment({...interview});
        }
    }

    const checkAssessmentProgress = async (formModel) => {

        let interview = null;
        if (formModel) {
            let interviewProps = TB.pick({...talent},
                ['talent_disciplines', 'talent_service_groups', 'skills', 'talent_skill_score']
            );

            interview = Interview.make({...interviewProps, ...formModel})
        }
        if ((interview || talent.managerInterview()).assessmentMissingScores(type())) {
            let confirm = await TB.alert('warning', 'Assessment Not Finished',
                'The assessment has missing scores. Are you sure you want to submit your decision?',
                [{title: 'Yes, Continue'}, {title: 'Cancel'}]
            );

            return confirm
        }
        return true
    }

    const submitAssessment = async (assessment) => {

        return updateTalentAssessmentMutation.mutateAsync({assessment})
        //
        // interview = updatedTalent.managerInterview();
        //
        // // await this.promisedState({
        // //     talent: updatedTalent,
        // //     assessment: {...interview},
        // //     hasStarted: interview.assessmentStarted(type())
        // // })
        // // await TB.wait(400);
        //
        // // await this.promisedState({
        // //     isLoading: false
        // // })
    }

    const hasStarted = useMemo(() => {
        if (isLoading || !talent) {
            return false;
        }
        let interview = talent.managerInterview();
        return interview?.assessmentStarted('capability');
    }, [isLoading, talent]);


    const interview = useMemo(() => {
        return talent?.managerInterview()
    }, [isLoading, talent]);
    return (
        <Modal
            okText={null}
            zIndex={199}
            footer={null}
            cancelText={null}
            title={null}
            className="talent-assessment-modal"
            open={true}
            closeable={!props.isDisabled}
            maskClosable={!props.isDisabled}
            style={{top: 20}}
            destroyOnClose={true}
            width={'85%'}
            onCancel={() => props.onClose()}
        >
            <div className="assessment-modal-container pt-4">

                {isLoading && <LoadingBanner message={TB.isString(isLoading) ? isLoading : "Loading"}/>}

                {TB.isObject(error) && (
                    <ErrorBanner {...error} onRetry={refetch}/>
                )}

                {!isLoading && !error && (
                    <div className="flex flex-col items-stretch">
                        <div className="user-info" style={{flexBasis: '100%'}}>
                            <div className="user-details justify-start">
                                <div className="user-info-image">
                                    <Img
                                        loader={(
                                            <div className="img-fluid img-loader"><LoadingSpinner/></div>
                                        )}
                                        unloader={<UserImageCircle user={talent} hideTooltip={true} size={90}/>}
                                        src={talent.image_path}
                                        className="img-grayscale img-fluid"/>
                                </div>
                                <div className="user-info-details">
                                    <p><b>Name:</b> {talent.fullName()}</p>

                                    <p>
                                        <b>Job Title:</b> {talent.job_title ? TB.truncate(
                                        TB.capitalize(talent.job_title), {length: 50}
                                    ) : 'N/A'}
                                    </p>

                                    <p>
                                        <b>Location:</b> {talent.location ? <span>
                                        {talent.location.city}{!!talent.location.state && `, ${talent.location.state}`}
                                    </span> : 'N/A'}
                                    </p>

                                    <p>
                                        <b>Email:</b> {talent.email ? (
                                        <a href={`mailto:${talent.email}`}
                                           target="_blank">{talent.email}</a>
                                    ) : 'N/A'
                                    }
                                    </p>
                                    {talent.phone && (
                                        <p>
                                            <b>Phone:</b> {talent.phone ? (
                                            <a href={`tel:${talent.phone}`}
                                               target="_blank">{talent.phoneNumber()}</a>
                                        ) : 'N/A'}
                                        </p>
                                    )}
                                    <p><b>Registered
                                        At:</b> {talent.registered_at ? TB.moment(talent.registered_at).format('ll') : "N/A"}
                                    </p>


                                </div>
                            </div>

                            {!isEditing ? (
                                <CapabilityScoreSummary talent={talent}/>
                            ) : (
                                <div className="user-instructions">
                                    <h4>RATINGS LEGEND</h4>
                                    <p>1 - does not meet our standard</p>
                                    <p>2 - has some of what we want but not quite enough to feel confident</p>
                                    <p>3 - good enough to be a solid contributor on a project</p>
                                    <p>4 - has most of what we're looking for; great craft and could lead</p>
                                    <p>5 - Knocks it out of the park. Top performer.</p>
                                </div>
                            )}
                        </div>
                        {!isEditing && (
                            <div className="assessment-actions">
                                <Link target="_blank" to={`/talent-profiles/${talent.id}`}
                                      className="btn btn-dark btn-xs mx-2">
                                    View Client-Facing Profile
                                </Link>
                                <button disabled={updateTalentAssessmentMutation.isLoading} onClick={() => {
                                    setIsEditing(true)
                                }} className="btn btn-primary btn-xs mx-2">
                                    {hasStarted ? 'Edit/View Assessment': 'Start Assessment'}
                                </button>

                                {hasStarted && (
                                    interview.hasAssessmentStatus(type()) ? (
                                        <button disabled={updateTalentAssessmentMutation.isLoading}
                                                onClick={() => interview.assessmentWasApproved(type())
                                            ? rejectAssessment(interview)
                                            : approveAssessment(interview)
                                        } className={TB.mapClass("btn btn-xs mx-2", {
                                            'btn-success': interview.assessmentWasRejected(type()),
                                            'btn-danger': interview.assessmentWasApproved(type()),
                                        })}>
                                            Change Status to {interview.assessmentWasApproved(type()) ? 'Rejected' : 'Approved'}
                                        </button>
                                    ) : [
                                        <button disabled={updateTalentAssessmentMutation.isLoading}
                                                key="approve-btn" onClick={() => approveAssessment(interview)}
                                                className="btn btn-xs btn-success mx-2">
                                            <i className="fas fa-thumbs-up"/>
                                            Approve Talent
                                        </button>,
                                        <button disabled={updateTalentAssessmentMutation.isLoading}
                                                key="reject-btn" onClick={() => rejectAssessment(interview)}
                                                className="btn btn-xs btn-danger mx-2">
                                            <i className="fas fa-thumbs-down"/>
                                            Reject Talent
                                        </button>
                                    ]
                                )}

                            </div>
                        )}

                        {!isEditing ? (
                            <div className="flex flex-row flex-wrap profile-details">

                                {profileScoring().map(({label, propName}) => {
                                    let items = talent[propName];

                                    return (
                                        (<div className="w-full" key={TB.slugify(label)}>
                                            <h4 className="text-underline text-lg">
                                                {label}
                                            </h4>
                                            {items?.length > 0 ? (
                                                <ul className="list-disc pl-4 flex-wrap md:flex">
                                                    {TB.map(items, item => {

                                                        let status = propName === 'talent_disciplines' && Interview.marketplaceStatus(propName, item, true)
                                                        return (
                                                            <li key={`${TB.slugify(label)}-${item.id}`}
                                                                className="text-xs pr-6 p-2.5 sm:basis-1/2 md:basis-1/3">
                                                                <p>
                                                                    {item.name}
                                                                    &nbsp;
                                                                    {status && (
                                                                        <span
                                                                            className={`text-xs font-medium px-1 py-0.5 rounded ${status.className}`}>
                                                                            {status.title}
                                                                        </span>
                                                                    )}
                                                                </p>

                                                                {TB.isDefined(item.self_score) && ((
                                                                        <p className="text-xxs font-bold">{selfScore(item.self_score)}</p>
                                                                    )
                                                                )}

                                                            </li>
                                                        )
                                                    })}
                                                </ul>
                                            ) : (
                                                <h5 className="text-center text-muted italic">
                                                    None Submitted
                                                </h5>
                                            )}
                                            <hr/>
                                        </div>)
                                    );
                                })}

                                <div className="w-full flex flex-col items-stretch justify-center">
                                    <AvailabilityPanel user={talent} readOnly={true} columnProps={{xl: 12, lg: 12}}
                                                       colClass="!md:w-full lg:!w-full xl:!w-full xl:!max-w-[auto] xl:!basis-auto"/>
                                </div>
                            </div>
                        ) : (
                            <TalentCapabilityAssessmentModal
                                talent={talent}
                                submitAssessment={submitAssessment}
                                approveAssessment={approveAssessment}
                                rejectAssessment={rejectAssessment}
                                isDisabled={updateTalentAssessmentMutation.isLoading}
                                onClose={() => {
                                    setIsEditing(false)
                                }}
                            />
                        )}

                    </div>
                )}

            </div>

        </Modal>
    )
};

export default AssessmentModal;